<template>
    <the-section class="gallery">
        <div class="images">
            <div
                v-for="media in section.medias"
                class="image"
                ref="image"
                :key="media._uid"
            >
                <img :src="getUrl(media.directus_files_id.id)" />
            </div>
        </div>
    </the-section>
</template>

<script>
import getters from "@/mixins/getters.mixin";
import TheSection from "@/components/TheSection";
import { scroll, scrollBatch, clearScroll } from "@/services/scroll.animation";

export default {
    mixins: [getters],
    components: { TheSection },
    props: {
        name: {
            type: String,
            required: true,
        },
    },
    computed: {
        section() {
            return this.getGallery(this.name);
        },
        colors() {
            return this.gallery.colors;
        },
        id() {
            return `gallery-section-${this.name}`;
        },
        idBatch() {
            return `gallery-section-images-${this.name}`;
        },
    },
    mounted() {
        scroll(this.id, this.$el, this.section.colors);
        scrollBatch(this.idBatch, this.$refs.image);
    },
    beforeDestroy() {
        clearScroll(this.id);
        clearScroll(this.idBatch);
    },
};
</script>

<style lang="sass" scoped>
@import ~include-media/dist/include-media
@import ~styles/base
@import ~styles/typography

.images
    width: 100%
    margin: auto
    display: flex
    flex-direction: column
    gap: 5vw

    +media('>=small')
        width: 66.667%

    .image

        +media('>=small')
            opacity: 0
            transform: translateY(5%)

        img
            aspect-ratio: 3/2
            border-radius: 5px
            border: 0.5em solid white
            width: 100%
            object-fit: cover
            object-position: center
            box-shadow: 0 0 10px rgba(0,0,0,0.2)
            box-sizing: border-box

            +media('<small')
                border: 0.25em solid white
</style>
